// extracted by mini-css-extract-plugin
export var bounce = "_nw-1";
export var generatingText = "_nw-6";
export var lightning = "_nw-4";
export var popup = "_nw-5";
export var progressBar = "_nw-7";
export var progressFill = "_nw-8";
export var progressShimmer = "_nw-9";
export var progressText = "_nw-a";
export var shimmer = "_nw-3";
export var uploadIcon = "_nw-0";
export var uploadingText = "_nw-2";